import React from 'react';
import { Column, Copy, Row } from '@grubhubprod/gh-cookbook-react';
import {
  Loader,
  Flex,
  Stack,
  Square,
} from '@grubhubprod/gh-cookbook-react/dist';
import { RestrictionsList } from 'src/common/OrderRestrictions/RestrictionsList/RestrictionsList';
import { ItemRestrictionsEnableControl } from 'src/components/enterprise/features/Corporate/components/Form/ItemRestrictionsWrapper/ItemRestrictionsEnableControl';
import { useToggleRestrictions } from 'src/components/enterprise/features/Corporate/components/Form/common/hooks/useToggleRestrictions';
import { useCorporateItemRestrictions } from 'src/components/enterprise/features/Corporate/components/Form/ItemRestrictionsWrapper/hooks/useCorporateItemRestrictions';
import { useGroupCheckboxValidate } from 'src/components/CookbookCheckboxWrapper/hooks/useGroupCheckboxValidate';
import { requiredRestrictionsValidator } from 'src/common/OrderRestrictions/orderRestrictions.utils';

export function ItemRestrictionsWrapper(): JSX.Element {
  const restrictionsEnabled = useToggleRestrictions({
    restrictionsFieldName: 'defaultItemRestrictions',
    toggleFieldName: 'enableItemRestrictions',
  });

  const { isLoading, groupedItemRestrictions, itemRestrictionsMeta } =
    useCorporateItemRestrictions();

  const { error, validate } = useGroupCheckboxValidate({
    optionKeys: (itemRestrictionsMeta || []).map(
      (restriction) => restriction.type
    ),
    name: 'defaultItemRestrictions',
    validateGroup: requiredRestrictionsValidator,
  });

  if (isLoading) {
    return (
      <Flex alignItems="center" justifyContent="center">
        <Loader size="md" />
      </Flex>
    );
  }

  return (
    <>
      <Row gutter={12}>
        <Column phone={6} gutter={12}>
          <ItemRestrictionsEnableControl
            name="enableItemRestrictions"
            id="enableItemRestrictions"
          />
        </Column>
        {error && (
          <Column phone={12} gutter={12}>
            <Stack y="sm">
              <Copy variant="body" color="danger">
                {error.message}
              </Copy>
            </Stack>
          </Column>
        )}
      </Row>
      {restrictionsEnabled && (
        <Square bg="globals.white" inset="lg" dimension="1">
          <Row gutter={12}>
            <Column phone={12} gutter={12}>
              <Stack y="sm">
                <Copy variant="body">
                  We recommend each company follow their internal ordering
                  policies or guidelines to enforce these restrictions. The
                  accuracy of our restricted item categories is not guaranteed.
                </Copy>
              </Stack>
            </Column>
          </Row>
          <Row gutter={12}>
            <Column phone={12} gutter={12}>
              <RestrictionsList
                groupedRestrictions={groupedItemRestrictions}
                name="defaultItemRestrictions"
                rules={{
                  validate,
                }}
              />
            </Column>
          </Row>
        </Square>
      )}
    </>
  );
}
